import React, {useState, useEffect} from 'react';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile;
}

function GeneralCardWithoutImage(props) {

  const isMobile = useIsMobile();


  return (
    <>
      <div className="d-flex justify-content-center" style={{ marginTop: "20px" }}>
        <div className="card mb-3" style={{ maxWidth: isMobile ? "80%" : "30%" }}>
          <div className="row g-0">
            <div className="card-body">
                <h5 className="card-title">{props.title}</h5>
                <p className="card-text">{props.text}</p>
                <p className="card-text"><small className="text-muted">{props.footer}</small></p>
            </div>
          </div>
        </div>
      </div>
    </>
    
  );
}

export default GeneralCardWithoutImage;